"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const ThemeContext_1 = require("../../../interface/ThemeContext");
const email_1 = require("../../../redux/reducers/email");
const react_phone_input_2_1 = __importDefault(require("react-phone-input-2"));
const connector = (0, react_redux_1.connect)((state) => ({}), (dispatch) => {
    return {
        sendContactUsEmail(data) {
            dispatch((0, email_1.contactUs)(data));
        },
    };
});
exports.default = connector(({ sendContactUsEmail }) => {
    const themeContext = (0, ThemeContext_1.useThemeContext)();
    const [submitted, setSubmitted] = (0, react_1.useState)({
        clicked: false,
        submitted: false,
    });
    const [formData, setFormData] = (0, react_1.useState)({
        name: "",
        email: "",
        phone: "",
        message: "",
    });
    const handleChange = ({ target: { name, value }, }) => {
        setFormData(Object.assign(Object.assign({}, formData), { [name]: value }));
    };
    return (react_1.default.createElement("div", { className: "contact-us-container", id: "contact-us-container" },
        react_1.default.createElement("div", { style: {
                maxWidth: 640,
                paddingLeft: 40,
                paddingRight: 40,
            }, className: "contact-us-form-container container" },
            react_1.default.createElement("div", { className: "contact-us-form-header mb-0" },
                react_1.default.createElement("h3", null, "Contact Us"),
                react_1.default.createElement("p", null, submitted.submitted ? (react_1.default.createElement(react_1.default.Fragment, null,
                    "Thank you for contacting us! We've received your message and will be in touch within 24 hours. We appreciate your patience and look forward to speaking with you. ",
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("br", null),
                    "If you need immediate assistance please email",
                    " ",
                    react_1.default.createElement("a", { href: "mailto:help@swivvl.com" }, "help@swivvl.com"))) : ("Discover how our services can transform your business. Fill out the form below, and a member of our team will reach out to explore how we can help drive your success."))),
            react_1.default.createElement("form", { className: "contact-us-form container", style: {
                    display: submitted.submitted ? "none" : "flex",
                } },
                react_1.default.createElement("div", { className: "contact-us-input-container" },
                    react_1.default.createElement("label", { htmlFor: "contact-us-name" }, "Full Name"),
                    react_1.default.createElement("input", { id: "contact-us-name", type: "text", name: "name", onChange: handleChange, value: formData.name, placeholder: "Name Surname" })),
                react_1.default.createElement("div", { className: "contact-us-input-container" },
                    react_1.default.createElement("label", { htmlFor: "contact-us-email" }, "E-Mail"),
                    react_1.default.createElement("input", { id: "contact-us-name", type: "text", name: "email", onChange: handleChange, value: formData.email, placeholder: "example@example.com" })),
                react_1.default.createElement("div", { className: "contact-us-input-container" },
                    react_1.default.createElement("label", { htmlFor: "contact-us-phone" }, "Phone"),
                    react_1.default.createElement(react_phone_input_2_1.default
                    //  class="number"
                    , { 
                        //  class="number"
                        containerStyle: {
                            width: "100%",
                        }, specialLabel: "", inputClass: "form-control", country: "us", value: formData.phone, onChange: (phone) => setFormData(Object.assign(Object.assign({}, formData), { phone })) })),
                react_1.default.createElement("div", { className: "contact-us-input-container" },
                    react_1.default.createElement("label", { htmlFor: "contact-us-message" }, "Message"),
                    react_1.default.createElement("textarea", { id: "contact-us-message", placeholder: "Message", name: "message", onChange: handleChange, value: formData.message })),
                react_1.default.createElement("button", { onClick: (e) => {
                        e.preventDefault();
                        setSubmitted({ submitted: false, clicked: true });
                        sendContactUsEmail({
                            body: formData,
                            cb() {
                                var _a;
                                setSubmitted({ submitted: true, clicked: false });
                                (_a = document
                                    .getElementById("contact-us-container")) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
                            },
                        });
                    } }, submitted.clicked ? (react_1.default.createElement("div", { className: "spinner-border", role: "status" },
                    react_1.default.createElement("span", { className: "visually-hidden" }, "..."))) : ("Send"))))));
});
